import { useEffect, useState } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Circle } from "@mui/icons-material";

const ImageCarousel = ({ images, time }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);
    const extendedImages = [images[images.length - 1], ...images, images[0]];

    useEffect(() => {
        const interval = setInterval(() => {
            handleNext();
        }, time);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = () => {
        setIsTransitioning(true);
        setActiveIndex((prevIndex) => prevIndex + 1);
    };

    const handlePrev = () => {
        setIsTransitioning(true);
        setActiveIndex((prevIndex) => prevIndex - 1);
    };

    useEffect(() => {
        if (activeIndex === extendedImages.length - 1) {
            setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(1);
            }, 800);
        } else if (activeIndex === 0) {
            setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(images.length);
            }, 800);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex]);

    return (
        <Box sx={{position: "relative", width: "100%", mx: "auto", overflow: "hidden", alignContent: "center"}}>
            <IconButton onClick={handlePrev} sx={{ position: 'absolute', top: '50%', left: 0, transform: 'translateY(-50%)', zIndex: 1 }}>
                <ArrowBackIos />
            </IconButton>

            <Box sx={{display: 'flex', transition: isTransitioning ? 'transform 0.8s ease-in-out' : 'none', transform: `translateX(-${activeIndex * 100}%)`}}>
                {extendedImages.map((img, index) => (
                    <Box
                        key={index} component="img" src={img} alt={`Image ${index}`}
                        sx={{minWidth: '100%', objectFit: 'cover'}}
                    />
                ))}
            </Box>

            <IconButton onClick={handleNext} sx={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)', zIndex: 1 }}>
                <ArrowForwardIos />
            </IconButton>

            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 2 }}>
                {images.map((_, index) => (
                    <Circle
                        key={index}
                        sx={{
                            fontSize: 10,
                            color: index === (activeIndex - 1 + images.length) % images.length ? 'primary.main' : 'grey.400',
                            cursor: 'pointer'
                        }}
                        onClick={() => setActiveIndex(index)}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default ImageCarousel;
